import type { Quest } from '../types';

/** Reopen only completed work; deletion and restore have their own rules. */
export function reopenQuest(quest: Quest): Quest {
  if (quest.status === 'completed' && quest.goals.length > 0 && quest.goals.some(goal => !goal.completed)) {
    return { ...quest, status: 'active', completedAt: undefined };
  }
  return quest;
}
